import Vue from 'vue'
import Router from 'vue-router'
import utils from '@/utils';
// import Mine from '../views/MineView/Mine'


const PhoneCodeLogin = () => import('views/RebateLogin/login/PhoneCodeLogin')
const loginSwitch = () => import('views/RebateLogin/login/LoginSwitch')
const autoLogin = () => import('views/RebateLogin/login/AutoLogin')
const Register = () => import('views/RebateLogin/login/Register')
// const ChangePsw = () => import('views/RebateLogin/userCenter/ChangePsw')
Vue.use(Router)


let routes = [
  {
    path: "/phoneCodeLogin",
    component: PhoneCodeLogin
  },
  {
    path: "/loginSwitch",
    component: loginSwitch
  },
  {
    path: "/autoLogin",
    component: autoLogin
  },
  {
    path: "/register",
    component: Register
  },
]

let type = utils.getUrlKey("type")
if ("rebateLogin" === type) {
  let param = utils.getUrlKey("param")
  let savingAccounts = JSON.parse(param)['savingAccounts']
  // console.log(savingAccounts);
  if (savingAccounts !== undefined && savingAccounts.indexOf("username") !== -1) {
    let haveAutoLoginAccount = false;
    savingAccounts = JSON.parse(savingAccounts);
    // 判断所有账号是不是有自动登录的，有就要将默认启动页面设置为自动登录的
    for (let index = 0; index < savingAccounts.length; index++) {
      const accountJson = savingAccounts[index];
      let autoLogin = accountJson['autoLogin'];
      if ("true" === autoLogin) {
        haveAutoLoginAccount = true;
        break;
      }
    }
    if (haveAutoLoginAccount) {
      routes.push(
        {
          path:"/index.html",
          redirect: "/autoLogin"
        },
      );
      routes.push(
        {
          path:"/",
          redirect: "/autoLogin"
        },
      );
    }else {
      routes.push(
        {
          path:"/index.html",
          redirect: "/loginSwitch"
        },
      );
      routes.push(
        {
          path:"/",
          redirect: "/loginSwitch"
        },
      );
    }
  }else{
    routes.push(
      {
        path:"/index.html",
        redirect: "/phoneCodeLogin"
      },
    );
    routes.push(
      {
        path:"/",
        redirect: "/phoneCodeLogin"
      },
    );
  }
}



export default new Router({
  routes,
  // mode: 'history',// 模式，避免地址栏显示多余的#
  linkActiveClass: "router-active" //当前选中的 router-link 的class的值，可以用于在style中设置这个class name,展示不同的选中状态
})



// WEBPACK FOOTER //
// ./src/rebateLogin/router/index.js